import {
  FontAwesomeIcon
} from "./chunk-APS5QAFW.js";
import {
  cn,
  twVariants
} from "./chunk-LJ5F4WFH.js";

// src/Link/Link.tsx
import React from "react";
import { Slot, Slottable } from "@radix-ui/react-slot";
var linkStyles = twVariants({
  slots: {
    root: [
      "inline-flex items-center gap-1.5 text-body-1 font-normal text-information-link-enabled transition-colors",
      "hover:underline",
      "active:text-information-link-visited",
      "visited:text-information-link-visited"
    ],
    externalIcon: ["h-4 w-4"]
  },
  variants: {
    disabled: {
      true: {
        root: "pointer-events-none text-information-link-disabled visited:text-information-link-disabled active:text-information-link-disabled"
      }
    }
  }
});
var Link = React.forwardRef(
  ({
    className,
    asChild = false,
    external = false,
    disabled = false,
    children,
    ...props
  }, ref) => {
    const Comp = asChild ? Slot : "a";
    const { root, externalIcon } = linkStyles({ disabled });
    return /* @__PURE__ */ React.createElement(Comp, { ref, className: cn(root(), className), ...props }, /* @__PURE__ */ React.createElement(Slottable, null, children), external && /* @__PURE__ */ React.createElement(
      FontAwesomeIcon,
      {
        name: "arrow-up-right:regular",
        className: externalIcon()
      }
    ));
  }
);
Link.displayName = "Link";

export {
  Link
};
//# sourceMappingURL=chunk-VI3HNRVJ.js.map